"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function buildRawType(rawType) {
    return typeof rawType === "object"
        ? {
            kind: "ListType",
            type: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: rawType[0],
                },
            },
        }
        : {
            kind: "NamedType",
            name: {
                kind: "Name",
                value: rawType,
            },
        };
}
exports.buildRawType = buildRawType;
/** Builds the GraphQL AST for a given Houbolt type */
function buildType(type) {
    return isNonNull(type)
        ? {
            kind: "NonNullType",
            type: buildRawType(type[0]),
        }
        : buildRawType(type);
}
exports.buildType = buildType;
/** Returns whether the provided type is non null */
function isNonNull(type) {
    return typeof type === "object" && type[1] === "!";
}
exports.isNonNull = isNonNull;
